<ion-card *ngIf="page === 'contacto'" id="contacto">
  <ion-card-header>
    <ion-card-title>{{ item.Titulo }}</ion-card-title>
    <ion-card-subtitle *ngIf="item.Subtitulo !== ''" mode="md">{{
      item.Subtitulo
    }}</ion-card-subtitle>
  </ion-card-header>
  <ion-card-content mode="md">
    <ion-button
      size="large"
      (click)="llamar(item.Telefono)"
      *ngIf="item.Telefono"
    >
      {{ item.Telefono }}
    </ion-button>
    <ion-button size="large" (click)="openUrl(item.UrlWeb)" *ngIf="item.UrlWeb">
      Gepp.com.mx
    </ion-button>
  </ion-card-content>
</ion-card>

<ng-container *ngIf="page === 'Notificaciones'">
  <ion-card
    id="notificaciones"
    type="button"
    button
    [ngClass]="!item.view ? 'color-card-gray' : 'color-card-white'"
    (click)="notificationClicked(item)"
  >
    <ion-card-header>
      <ion-card-title>
        <div
          id="container-title"
          [ngStyle]="{
            padding: item.view ? '6px 16px 0px 16px' : '10px 16px 0px 16px'
          }"
          [ngClass]="!item.view ? 'color-card-gray' : 'color-card-white'"
        >
          <ion-icon
            *ngIf="item.view"
            name="checkmark-circle-outline"
            color="correct"
          ></ion-icon>
          <ion-label id="titulo" class="no-ellipsis">
            {{ item.title }}
          </ion-label>
          <p id="date" *ngIf="item.scheduleDate !== ''">
            {{ item.scheduleDate }}
          </p>
        </div>
      </ion-card-title>
    </ion-card-header>
    <ion-card-content mode="md">
      <span>
        {{ item.message }}
      </span>
    </ion-card-content>
  </ion-card>
</ng-container>
